<template>
	<VInput
		ref="company-okpo-input"
		v-model="company.additionalAttributes.okpo.value"
		:label="company.additionalAttributes.okpo.name"
		layout="vertical"
		:validate-method="ByUtils.validateOKPO"
		:disabled="readOnly"
	/>

	<VInput
		ref="company-unp-input"
		v-model="company.additionalAttributes.unp.value"
		:label="company.additionalAttributes.unp.name"
		layout="vertical"
		:validate-method="ByUtils.validateUNP"
		:disabled="readOnly"
	/>
</template>

<script>

import ByUtils from "@/core/utils/regional/ByUtils";
import Company from "@/domains/Companies/Company.js";

export default {
	name:   'BYAdditionalAttributes',

	props: {
    company: {
      type:     Company,
      required: true
    },
		readOnly: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			ByUtils,
		}
	},
};
</script>
